import config from './data/config';
import { compile } from 'path-to-regexp';

function createPathObject(path)
{
    return {
        path: path,
        toPath: compile(path)
    };
}

const root = createPathObject(config.baseurl);

const weeklyScoredSchoolGlobal = createPathObject(config.baseurl + "Apollios/:lang");
const weeklyScoredSchool = createPathObject(config.baseurl + "Apollios/:lang/:floorId");
const weeklyHighestScoredAllSchoolGlobal = createPathObject(config.baseurl + "Apollios/highestScored/:lang");
const weeklyHighestScoredAllSchool = createPathObject(config.baseurl + "Apollios/highestScored/:lang/:floorId");
const solarEnergyScoredSchool = createPathObject(config.baseurl + "Apollios/solarEnergy/:lang/:floorId");

const embeddedHighScore = createPathObject(config.baseurl + "Apollios/:lang/embedded/highestScored/:game");

export {
    root,
    weeklyScoredSchoolGlobal,
    weeklyScoredSchool,
    weeklyHighestScoredAllSchool,
    weeklyHighestScoredAllSchoolGlobal,
    solarEnergyScoredSchool,
    embeddedHighScore
};